document.addEventListener('DOMContentLoaded', contactInit);

function contactInit() {
  contact();
}

function contact() {
  // GF 3.0 JS API — fires after confirmation is displayed
  // eslint-disable-next-line no-undef
  if (typeof gform !== 'undefined' && typeof gform.addAction === 'function') {
    // eslint-disable-next-line no-undef
    gform.addAction('gform/ajax/pre_display_confirmation', () => {
      for (const el of document.querySelectorAll('.contact .contact-image-wrapper')) {
        el.classList.add('position-relative');
      }
    });
  }
}
